import { render, staticRenderFns } from "./classDetails.vue?vue&type=template&id=42eec5a4&scoped=true"
import script from "./classDetails.vue?vue&type=script&lang=js"
export * from "./classDetails.vue?vue&type=script&lang=js"
import style0 from "./classDetails.vue?vue&type=style&index=0&id=42eec5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42eec5a4",
  null
  
)

export default component.exports